import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UserManager } from 'paycor-oidc-client';
import { createContext } from 'react';
import style from './style.module.scss';
import config from 'config';

export const userManager = new UserManager(config.securitySettings);

export const UserPrivContext = createContext({});

const AuthorizeUserPrivilege = ({ privileges, pageName, children }) => {
	const { t } = useTranslation();
	const { companyId, clientId } = useParams();

	const [hasEditPriv, setHasEditPriv] = useState(false);
	const [notHaveViewPriv, setNotHaveViewPriv] = useState(false);

	useEffect(() => {
		checkPrivileges();
	}, [companyId, clientId]);

	const checkPrivileges = async () => {
		const authenticatedUser = await userManager.getUser();
		const user = await userManager.getUserByAccessToken(authenticatedUser.access_token);
		setHasEditPriv(user.hasPrivilegeByClient(privileges.edit_priv, clientId));
		setNotHaveViewPriv(!user.hasPrivilegeByClient(privileges.view_priv, clientId));
	};

	if (notHaveViewPriv) {
		return (
			<div className={style.invalid_access}>
				<header className={style.page_name}>
					<span>{pageName}</span>
				</header>
				<span>{`${t('you_Dont_Have_Access_To_This_Page', "It looks like you don't have access to this page.")} ${t(
					('please_contact_administrator', 'Please contact your Company Administrator for help.')
				)}`}</span>
			</div>
		);
	}

	return <UserPrivContext.Provider value={{ hasEditPriv }}>{children}</UserPrivContext.Provider>;
};

AuthorizeUserPrivilege.propTypes = {
	privileges: PropTypes.object,
	children: PropTypes.element
};

export default AuthorizeUserPrivilege;
